import { VuexModule, Module, Mutation } from 'vuex-module-decorators';
import store from '@/store';

@Module({ store, namespaced: true, name: 'app/drawer' })
export class DrawerModule extends VuexModule {
  private opened = false;

  get getState(): boolean {
    return this.opened;
  }

  @Mutation
  setState(payload: boolean): void {
    this.opened = payload;
  }

  @Mutation
  toggleState(): void {
    this.opened = !this.opened;
  }
}
